var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterac({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 174.271 174.27402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-0.0004)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.271,
    height: 174.27399,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.99622,2.96921h140.277a14.029,14.029,0,0,1,14.029,14.029v140.279a14.028,14.028,0,0,1-14.028,14.028H16.9942a14.026,14.026,0,0,1-14.026-14.026V16.99722A14.028,14.028,0,0,1,16.99622,2.96921Z",
    fill: "#fdb913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2764,2.969a14.03026,14.03026,0,0,1,14.026,14.029V157.277a14.02878,14.02878,0,0,1-14.026,14.028H16.99739a14.02473,14.02473,0,0,1-14.028-14.028V16.998a14.02622,14.02622,0,0,1,14.028-14.029h140.279m0-2.969H16.99739A17.01543,17.01543,0,0,0,.0004,16.998V157.277a17.01584,17.01584,0,0,0,16.997,16.997h140.279a17.01477,17.01477,0,0,0,16.995-16.997V16.998A17.01436,17.01436,0,0,0,157.2764,0",
    transform: "translate(-0.0004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.95889,88.95432l-.014-30.139,7.867-1.867v3.951s2.038-5.196,6.767-6.402a4.52753,4.52753,0,0,1,2.188-.147v7.69a11.02253,11.02253,0,0,0-4.122.858c-2.907,1.148-4.37,3.653-4.37,7.477l.005,16.642Z",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4872,98.75491s-1.279-1.918-1.279-8.699v-15.007l-4.048.963v-6.182l4.057-.958v-6.739l8.365-1.976v6.739l5.911-1.404v6.175l-5.911,1.403s-.009,12.295,0,15.281c0,6.948,1.844,8.282,1.844,8.282Z",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3675,80.82492c0-5.358.763-9.267,2.401-12.267,1.949-3.56,5.145-5.88,9.801-6.94,9.177-2.087,12.489,3.345,12.361,10.629-.049,2.605-.037,3.874-.037,3.874l-16.168,3.8v.261c0,5.089,1.067,7.504,4.292,6.82,2.786-.588,3.561-2.333,3.781-4.491.036-.348.053-1.233.053-1.233l7.574-1.815s.018.62.007,1.316c-.066,2.892-.907,10.066-11.434,12.555-9.972,2.367-12.631-3.723-12.631-12.509m12.538-13.593c-2.679.608-4.084,3.236-4.145,7.59l8.133-1.937c.014-.197.016-.631.014-1.311-.014-3.287-1.03-5.022-4.002-4.342",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.07961,63.2c-.313-9.179,2.068-16.464,12.309-18.784,6.527-1.483,9.006.215,10.261,1.856,1.207,1.566,1.673,3.678,1.673,6.636l.007.543-8.012,1.904s-.006-1.08-.006-1.115c.006-3.508-.969-4.842-3.517-4.204-3.03.761-4.254,3.637-4.254,9.355,0,2.03.009,2.394.009,2.668,0,5.811.794,8.471,4.286,7.74,3.029-.626,3.444-3.286,3.493-5.618.006-.366.021-1.538.021-1.538l8-1.89s.008.591.008,1.248c-.02,7.62-4.036,12.422-11.56,14.173-10.366,2.43-12.396-3.56-12.718-12.974",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.38309,76.051c0-6.982,4.09-9.19,10.246-11.737,5.536-2.29,5.656-3.427,5.679-5.417.031-1.675-.746-3.108-3.502-2.405a4.15967,4.15967,0,0,0-3.336,3.943,14.36836,14.36836,0,0,0-.052,1.547l-7.762,1.833a15.44174,15.44174,0,0,1,.536-4.586c1.241-4.175,4.923-6.984,11.279-8.455,8.258-1.903,11.011,1.721,11.021,7.358V71.481c0,6.456,1.198,7.402,1.198,7.402l-7.62,1.803a16.55966,16.55966,0,0,1-1.021-2.737s-1.669,4.204-7.423,5.556c-6.043,1.425-9.243-2.32-9.243-7.454m15.872-9.534a28.771,28.771,0,0,1-4.054,2.374c-2.54,1.241-3.688,2.772-3.688,5.13,0,2.042,1.265,3.383,3.564,2.815,2.466-.622,4.178-2.923,4.178-6.12Z",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.749,119.88239a4.83715,4.83715,0,0,1-4.053-7.468l.054-.07.091-.024,11.378-2.686v8.641l-.177.041c-2.581.621-5.666,1.328-6.301,1.463a4.75831,4.75831,0,0,1-.992.103",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.749,130.93631a4.82982,4.82982,0,0,1-4.831-4.825,4.77892,4.77892,0,0,1,.778-2.627l.054-.081.091-.023,11.378-2.685v8.641l-.177.046c-2.581.619-5.666,1.334-6.301,1.461a5.11572,5.11572,0,0,1-.992.093",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.749,142.01151a4.83388,4.83388,0,0,1-4.831-4.829,4.76191,4.76191,0,0,1,.778-2.627l.054-.087,11.469-2.703v8.641l-.177.046c-2.726.656-5.753,1.34-6.301,1.461a5.04086,5.04086,0,0,1-.992.098",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.406 109.294 10.403 60.945 19.218 58.862 19.218 107.21 10.406 109.294",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3625,105.18069a5.4385,5.4385,0,1,0-10.877,0l.009,45.189a14.74433,14.74433,0,0,0,14.716,14.726c4.117,0,15.395-.02,15.395-.02l.005-18.852c.003-10.3.005-20.784.005-21.023a7.11906,7.11906,0,0,0-3.163-5.927l-13.721-9.319s-.003,20.232-.003,21.162a1.17,1.17,0,1,1-2.34,0c0-.227-.026-23.141-.026-25.936",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7075,71.4653a11.89208,11.89208,0,0,0-7.846,6.066v-3.398l-7.937,1.878.009,21.7a8.12,8.12,0,0,1,8.357,1.461v-14.011c0-3.356,1.67-6.037,4.056-6.563,1.795-.394,3.294.248,3.294,3.445l.006,20.442,8.36-1.96v-21.625c0-5.243-2.019-8.908-8.299-7.435",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.17329,40.52094a5.16751,5.16751,0,1,1,5.163-5.165,5.17,5.17,0,0,1-5.163,5.165m0-9.685a4.519,4.519,0,1,0,4.518,4.52,4.52365,4.52365,0,0,0-4.518-4.52",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2916,32.27661h2.227a1.45621,1.45621,0,0,1,1.601,1.621c0,.818-.363,1.447-1.051,1.554v.012c.626.064.955.409.987,1.296.012.4.018.896.037,1.282a.6492.6492,0,0,0,.299.545h-1.138a1.05074,1.05074,0,0,1-.17-.56c-.035-.377-.026-.733-.043-1.191-.017-.688-.228-.989-.919-.989h-.824v2.74h-1.006Zm1.812,2.81a.92762.92762,0,0,0,1.007-1.023c0-.673-.291-1.027-.954-1.027h-.859v2.05Z",
    transform: "translate(-0.0004)",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterac);
export default __webpack_public_path__ + "static/media/Interac.2c06f5bb51ff7bd6c8e2ce3177e06045.svg";
export { ForwardRef as ReactComponent };